import type { ReactNode } from 'react';

export const EMPTY_PLACEHOLDER = '-';

/**
 * Empty-cell placeholder for DataTable columns.
 *
 * DataTable auto-shows the placeholder for bare empty cells (no `render`, or a
 * `render` returning null/undefined/''). When a column wraps its value in a JSX
 * element (e.g. `<div>{value}</div>`), DataTable can't see the emptiness — use
 * this helper inside `render` instead.
 *
 * @param value raw text used to decide emptiness (trimmed)
 * @param node  what to show when non-empty; defaults to the trimmed `value`
 */
export const withPlaceholder = (value: string | null | undefined, node?: ReactNode): ReactNode => {
  const text = value?.trim();
  if (!text) return EMPTY_PLACEHOLDER;
  return node ?? text;
};
